(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLookbook(root) {
    if (root.dataset.lbInit === 'true') return;
    root.dataset.lbInit = 'true';

    var track = root.querySelector('.lookbook__track');
    if (!track) return;
    var pageDots = root.querySelectorAll('[data-lb-page]');
    var slides = track.querySelectorAll('.lookbook__slide');
    var dots = root.querySelectorAll('[data-lookbook-dot]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobileMQ = window.matchMedia('(max-width: 749px)');

    /* Video's: niets speelt automatisch. De omslagfoto toont met een
       transparante playknop; tikken start/pauzeert. Uit beeld = pauze. */
    var vids = root.querySelectorAll('.lookbook__video');
    if (vids.length) {
      for (var vi = 0; vi < vids.length; vi++) {
        (function (vid) {
          var media = vid.closest('.lookbook__media');
          var playBtn = media ? media.querySelector('.lookbook__play') : null;

          function toggle() {
            if (vid.paused) {
              vid.muted = true;
              var p = vid.play();
              if (p && p.then) {
                p.then(function () { vid.muted = false; }).catch(function () {});
              } else {
                vid.muted = false;
              }
            } else {
              vid.pause();
            }
          }

          if (playBtn) playBtn.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
          vid.addEventListener('click', function () { toggle(); });
          vid.addEventListener('play', function () { if (media) media.classList.add('is-playing'); });
          vid.addEventListener('pause', function () { if (media) media.classList.remove('is-playing'); });
          vid.addEventListener('ended', function () { if (media) media.classList.remove('is-playing'); });
        })(vids[vi]);
      }

      /* Pauzeer video's die uit beeld scrollen (geen autostart bij binnenkomen). */
      if ('IntersectionObserver' in window) {
        var vObs = new IntersectionObserver(function (entries) {
          for (var e = 0; e < entries.length; e++) {
            if (!entries[e].isIntersecting && !entries[e].target.paused) entries[e].target.pause();
          }
        }, { root: track, threshold: 0.2 });
        for (var ov = 0; ov < vids.length; ov++) vObs.observe(vids[ov]);
      }
    }

    function step() {
      var slide = track.querySelector('.lookbook__slide');
      if (!slide) return track.clientWidth;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function setActivePage() {
      if (!pageDots.length) return;
      var i = Math.round(track.scrollLeft / step());
      if (i < 0) i = 0;
      if (i > pageDots.length - 1) i = pageDots.length - 1;
      for (var k = 0; k < pageDots.length; k++) {
        pageDots[k].setAttribute('aria-current', k === i ? 'true' : 'false');
      }
    }

    for (var pd = 0; pd < pageDots.length; pd++) {
      (function (btn, idx) {
        btn.addEventListener('click', function () {
          if (!slides[idx] || !slides[0]) return;
          var left = slides[idx].offsetLeft - slides[0].offsetLeft;
          track.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
        });
      })(pageDots[pd], pd);
    }
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(setActivePage);
    }, { passive: true });
    setActivePage();

    function positionCard(card) {
      card.style.removeProperty('--shift');
      if (mobileMQ.matches) return;
      var slide = card.closest('.lookbook__slide');
      if (!slide) return;
      var cr = card.getBoundingClientRect();
      var sr = slide.getBoundingClientRect();
      var shift = 0;
      if (cr.left < sr.left + 6) shift = (sr.left + 6) - cr.left;
      else if (cr.right > sr.right - 6) shift = (sr.right - 6) - cr.right;
      if (shift) card.style.setProperty('--shift', shift + 'px');
    }

    function closeCard(card) {
      if (!card || card.hidden) return;
      card.hidden = true;
      var dot = root.querySelector('[data-target="' + card.id + '"]');
      if (dot) dot.setAttribute('aria-expanded', 'false');
    }

    function closeAll() {
      var open = root.querySelectorAll('.lookbook__card:not([hidden])');
      for (var i = 0; i < open.length; i++) closeCard(open[i]);
    }

    function openCard(dot) {
      var card = document.getElementById(dot.dataset.target);
      if (!card) return;
      var wasOpen = !card.hidden;
      closeAll();
      if (wasOpen) return;
      card.hidden = false;
      dot.setAttribute('aria-expanded', 'true');
      card._opener = dot;
      positionCard(card);
      card.setAttribute('tabindex', '-1');
      try { card.focus({ preventScroll: true }); } catch (e) { card.focus(); }
    }

    for (var d = 0; d < dots.length; d++) {
      (function (dot) {
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          openCard(dot);
        });
      })(dots[d]);
    }

    var closers = root.querySelectorAll('.lookbook__card-close');
    for (var c = 0; c < closers.length; c++) {
      closers[c].addEventListener('click', function (e) {
        e.stopPropagation();
        var card = e.currentTarget.closest('.lookbook__card');
        var opener = card._opener;
        closeCard(card);
        if (opener) opener.focus();
      });
    }

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) { closeAll(); return; }
      if (!e.target.closest('.lookbook__card') && !e.target.closest('[data-lookbook-dot]')) {
        closeAll();
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var open = root.querySelector('.lookbook__card:not([hidden])');
        if (open) { var opener = open._opener; closeCard(open); if (opener) opener.focus(); }
      }
    });

    window.addEventListener('resize', function () {
      var open = root.querySelector('.lookbook__card:not([hidden])');
      if (open) positionCard(open);
    }, { passive: true });
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('.lookbook');
    for (var i = 0; i < roots.length; i++) initLookbook(roots[i]);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest ? e.target.closest('.lookbook__slide') : null;
      if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
